<template>
  <div style="height: 100%">
    <div
      style="
        position: absolute;
        width: 640px;
        top: 10px;
        left: 10px;
        background-color: rgba(5, 25, 65, 0.5);
        border: solid 1px rgba(95, 125, 165, 0.6);
        border-radius: 20px;
      "
    >
      <div style="padding: 15px 36px">
        <el-button
          type="warning"
          icon="el-icon-d-arrow-left"
          circle
          size="small"
          style="pointer-events: auto"
          @click="$router.push('/screen28896/parks')"
        />
        <span style="color: #c9d3fc">{{ entName }}</span>
        <div
          style="
            font-size: 12px;
            color: #c3c3c3;
            line-height: 150%;
            padding: 0 0 0 38px;
          "
        >
          {{ entDesc }}
        </div>
      </div>

      <transition name="fade">
        <div
          style="
            pointer-events: auto;
            font-size: 13px;
            color: #acd9fc;
            padding: 0px 0 20px 75px;
          "
        >
          <h3 style="color: #fca963; font-weight: normal">{{ houseName }}</h3>

          <el-button
            round
            type="warning"
            size="small"
            @click="houseShow = true"
          >
            智能控制
          </el-button>

          <el-button
            round
            type="success"
            size="small"
            @click="modelShow = true"
          >
            种植模型
          </el-button>

          <!-- <el-button
            round
            type="primary"
            size="small"
            @click="greenhouseShow = true"
          >
            标准化种植
          </el-button> -->
        </div>
      </transition>
    </div>

    <div
      v-if="houseSelected && hasCameras"
      style="position: absolute; width: 320px; top: 20px; right: 10px"
    >
      <div
        style="width: 320px; height: 180px; pointer-events: auto"
        v-for="(c, i) in cameras.channels"
        :key="i"
      >
        <iframe
          :src="`https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/${c}/${
            c === 'J07081424' ? 2 : 1
          }.live&control&autoplay=1&accessToken=${token}`"
          width="100%"
          height="100%"
          :id="`${new Date().getTime() + parseInt(Math.random() * 9999)}`"
          allowfullscreen
        >
        </iframe>
      </div>
    </div>

    <!-- 智能控制弹窗（显示国创制作的界面） -->
    <el-dialog
      :title="`${entName} ${houseName}`"
      :visible.sync="houseShow"
      width="1600px"
      top="2%"
      :append-to-body="true"
    >
      <!-- src="http://101.200.193.60:8089/PoLogin/LoginExternal?username=shjm&pwdMD5=E1-0A-DC-39-49-BA-59-AB-BE-56-E0-57-F2-0F-88-3E" -->
      <!--  src="http://120.26.202.178:10035/CFCM/#/cucumber/index" 国创的地址，2022年11月18日暂时废弃，改为接智棚平台 -->
      <iframe
        :src="ctrlWindowUrl"
        frameborder="0"
        style="width: 1560px; height: 760px"
      ></iframe>
    </el-dialog>

    <!-- 种植模型，把标准化管理系统的页面嵌入进来 -->
    <el-dialog
      :title="`${entName} ${houseName}`"
      :visible.sync="modelShow"
      width="1600px"
      top="2%"
      :append-to-body="true"
    >
      <iframe
        src="http://cmpzbzh.zkhfzhnyg.cn//?#/plantProject/3"
        frameborder="0"
        style="width: 1560px; height: 760px"
      ></iframe>
    </el-dialog>

    <!-- 新的标准化设施管理页面 -->
    <el-dialog
      :title="`${entName} ${houseName}`"
      :visible.sync="greenhouseShow"
      width="1600px"
      top="2%"
      :append-to-body="true"
    >
      <iframe
        src="http://greenhouse.zkhfzhnyg.cn"
        frameborder="0"
        style="width: 1560px; height: 760px"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
import map from './ControlDetailMap.js'
import { getToken } from '@/api/camera.js'

export default {
  name: 'ProductControlDetail',
  data() {
    return {
      currentHouse: undefined,
      townName: null, //乡镇的名称
      entName: null, //企业的名称
      entDesc: null, //企业的介绍
      control: {
        a: false,
        b: false,
        c: false,
        d: false,
        e: false,
        f: false,
        g: false,
        h: false,
        i: false,
      },
      player: undefined,
      houseShow: false, // 是否显示温室智能控制弹窗
      modelShow: false, // 是否显示种植模型
      greenhouseShow: false, // 是否显示新版温室标准化管理页面
      token: undefined,
      baseUrl: '',
    }
  },
  computed: {
    houseSelected() {
      return !!this.currentHouse
    },
    realtime() {
      return this.$store.getters.realtime
    },
    houseName() {
      const { currentHouse } = this
      return currentHouse ? currentHouse.title || '未命名设施' : ''
    },
    hasCameras() {
      const { currentHouse } = this
      if (!currentHouse.camera) return false
      if (!currentHouse.camera.channels) return false
      return currentHouse.camera.channels.length > 0
    },
    cameras() {
      const { currentHouse } = this
      if (currentHouse.camera) {
        this.baseUrl =
          'http://iotcloud.zkhfzhnyg.cn/api/ys7/' + currentHouse.camera.AppKey
        getToken(this.baseUrl).then((res) => {
          console.log('res', res.data)
          this.token = res.data.data.token
          console.log('token', this.token)
        })

        return currentHouse.camera
      }
      return undefined
    },
    ctrlWindowUrl() {
      const id = +this.$route.params.enterprise
      return id === 10000
        ? 'https://www.farm-iot.cn/Hosmart/Data'
        : 'http://47.105.215.208:8000/agriculture/overview'
    },
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
    const { town, enterprise } = this.$route.params
    map.start(this, town, enterprise)

    this.player = new EZUIPlayer('myPlayer')
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
    map.destroy()

    if (this.player) {
      this.player.stop()
    }
  },
  methods: {
    setProfile(val) {
      this.townName = val.townName
      this.entName = val.entName
      this.entDesc = val.entDesc
    },
    showHouse(val) {
      if (this.currentHouse) this.currentHouse = undefined
      this.$nextTick(() => {
        this.currentHouse = val
      })
    },
  },
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.el-divider__text {
  background-color: rgba(3, 25, 54, 1);
  color: #acd9fc;
}
.realtime-value {
  font-size: 24px;
}
.realtime-label {
  font-size: 14px;
  color: #d3e3ff;
  display: inline-block;
  width: 120px;
  line-height: 40px;
}
.realtime-unit {
  font-size: 12px;
  color: #d3e3ff;
}
.control-label {
  font-size: 14px;
  color: #d3e3ff;
  display: inline-block;
  width: 70px;
  line-height: 40px;
}
</style>




// WEBPACK FOOTER //
// src/components/screen28896/map-zone/mask/ControlDetail.vue